define([
    'uiComponent',
    'jquery',
    'js/breakpoints',
    'Lfi_ImageService/js/generateUrl',
    'foundation/entries/plugins/foundation.util.mediaQuery'
], function (Component, $, breakpoints, generateUrl) {
    'use strict';

    /**
     * @deprecated
     * Use 'Lfi_Cms/js/video' instead as it handles the autoplay option
     */

    return Component.extend({
        defaults: {
            srcset: {
                square: generateUrl('Danner_RecraftingAnthem_1x1', {mediaType: 'video'}),
                landscape: generateUrl('Danner_RecraftingAnthem_16x9', {mediaType: 'video'})
            }
        },

        isPlaying: function () {
            return this.element.currentTime > 0
                && !this.element.paused
                && !this.element.ended
                && this.element.readyState > 2;
        },

        onClick: function () {
            if (this.isPlaying()) {
                this.element.pause();
            } else {
                this.element.play();
            }
        },

        onBreakpointChange: function () {
            const aspect = $(window).width() < breakpoints.medium? 'square' : 'landscape';
            this.element.src = this.srcset[aspect];
        },

        initialize: function (config, element) {
            this._super();
            this.element = element;
            $(this.element).on('click', this.onClick.bind(this));

            // TODO replace with Bootstrap breakpoint change listener?
            this.onBreakpointChange();
            $(window).on('changed.zf.mediaquery', this.onBreakpointChange.bind(this));
        }
    });
});
